






















import { appModule } from "@/store/modules/app";
import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";

@Component({
  components: {}
})
export default class TekananDarahNew extends Vue {
  @Prop() setDarah: { sistole: number; diastole: number } = {
    sistole: null,
    diastole: null
  };
  @Prop() setLabel!: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: false }) readonly?: boolean;
  @Prop({ default: "" }) errorMessages?: string;
  @Ref() readonly inputElement: HTMLInputElement;

  label = "Tekanan Darah";
  placeholder = "";
  //validasi = [v => this.cek(v) || "*Pastikan Format Benar, contoh: 120/90"];

  validasi: any[] = [];

  validation = [v => this.cek(v) || "*Pastikan Format Benar, contoh: 120/90"];

  handleDelete() {
    const last = this.td.substr(this.td.length - 1);
    if (last == "/") this.td = this.td.substring(0, this.td.length - 1);
  }

  get td(): string {
    console.log("get td", this.setDarah.sistole, this.setDarah.diastole);

    if (
      this.setDarah["sistole"] &&
      (!this.setDarah["diastole"] || this.setDarah.diastole < 1)
    ) {
      const prefix = this.setDarah.sistole > 99 ? "/" : "";
      return this.setDarah["sistole"].toString() + prefix;
    } else if (this.setDarah["sistole"] && this.setDarah["diastole"]) {
      return this.setDarah["sistole"] + "/" + this.setDarah["diastole"];
    } else {
      return null;
    }
  }

  set td(val) {
    const tensiArray = val.split("/").map(item => (item === null ? "0" : item));
    const tensi = { sistole: "0", diastole: "0" };

    if (tensiArray.length < 2) {
      tensi.sistole = tensiArray[0];
    } else {
      tensi.sistole = tensiArray[0];
      tensi.diastole = tensiArray[1];
    }

    this.$emit("setTensi", tensi);
  }

  get sistole() {
    return this.setDarah.sistole;
  }

  get diastole() {
    return this.setDarah.diastole;
  }

  @Watch("sistole")
  changeSistole(val) {
    if (val && val.toString().includes(",")) {
      this.setDarah.sistole = val.toString().replace(",", ".");
    }
  }

  @Watch("diastole")
  changeDiastole(val) {
    if (val && val.toString().includes(",")) {
      this.setDarah.diastole = val.toString().replace(",", ".");
    }
  }

  cek(val) {
    if (
      isNaN(this.setDarah.sistole) ||
      this.setDarah.sistole < 1 ||
      isNaN(this.setDarah.diastole) ||
      this.setDarah.diastole < 1
    ) {
      return false;
    }

    if (this.setDarah.sistole > 300) {
      appModule.sendErrorAlert(
        "Sistole " + this.setDarah.sistole + " terlalu tinggi! Anda yakin?"
      );
    }

    if (this.setDarah.diastole > 300) {
      appModule.sendErrorAlert(
        "Diastole " + this.setDarah.diastole + " terlalu tinggi! Anda yakin?"
      );
    }

    return true;
  }

  hintTextField = "";

  cekOnBlur() {
    if (!this.td) {
      this.validasi = [];
    } else {
      this.validasi = this.validation;
    }

    let warn = "";

    if (
      (this.setDarah.sistole || this.setDarah.diastole) &&
      (isNaN(this.setDarah.sistole) ||
        this.setDarah.sistole < 1 ||
        isNaN(this.setDarah.diastole) ||
        this.setDarah.diastole < 1)
    ) {
      warn = "Pastikan Format Benar dan diisi angka, contoh: 120/90";

      appModule.sendErrorAlert(warn);

      this.hintTextField = warn;
      this.td = "";
      return false;
    }

    if (this.setDarah.sistole && this.setDarah.sistole > 300) {
      warn =
        "Sistole " + this.setDarah.sistole + " terlalu tinggi! Anda yakin?";

      appModule.sendErrorAlert(warn);

      this.hintTextField = warn;

      return false;
    }

    if (this.setDarah.sistole && this.setDarah.sistole < 10) {
      warn =
        "Sistole " + this.setDarah.sistole + " terlalu rendah! Anda yakin?";

      appModule.sendErrorAlert(warn);

      this.hintTextField = warn;

      return false;
    }

    if (this.setDarah.diastole && this.setDarah.diastole > 300) {
      warn =
        "Diastole " + this.setDarah.diastole + " terlalu tinggi! Anda yakin?";

      appModule.sendErrorAlert(warn);

      this.hintTextField = warn;

      return false;
    }

    if (this.setDarah.diastole && this.setDarah.diastole < 10) {
      warn =
        "Diastole " + this.setDarah.diastole + " terlalu rendah! Anda yakin?";

      appModule.sendErrorAlert(warn);

      this.hintTextField = warn;

      return false;
    }

    this.hintTextField = warn;

    return true;
  }

  focus() {
    this.inputElement.focus();
  }
}
